// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/ol/ol.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: sans-serif;
}

.ol-control button {
	cursor: pointer;
	background-color: #eab811;
}

.ol-control button:focus {
	cursor: pointer;
	background-color: #eab811;
}

.ol-control button:hover {
	background-color: #eab811;
	color: #999999;
	border: 1px solid #999999;
}

.ol-attribution li {
	display: block;
	text-align: left;
}

.ol-attribution ul {
    font-size: 10px;
}

/* Overlay */
#geoline_ol_js_popup {
    background-color: #fff;
    border-radius: .2rem;
	border: 1px solid #D1D1D1;
}

#geoline_ol_js_popup > div {
    padding: 5px;
}

#geoline_ol_js_popup .header {
    border-bottom: unset;
    box-sizing: border-box;
    border-top-right-radius: .2rem;
    border-top-left-radius: .2rem;
    background-color: #f7f7f7;
    border-bottom: 1px solid #D1D1D1;
}

#geoline_ol_js_popup .arrow {
    bottom: calc(-.5rem - 1px);
    position: absolute;
    padding: unset;
    left: calc(100% / 2 - 0.5rem);
    width: 1rem;
    height: 0.5rem;
}

#geoline_ol_js_popup .arrow::after,
#geoline_ol_js_popup .arrow::before {
    position: absolute;
    display: block;
    content: "";
    box-sizing: border-box;
    border-color: transparent;
    border-top-color: transparent;
    border-style: solid;
}

#geoline_ol_js_popup .arrow::after {
    bottom: 1px;
    border-width: .5rem .5rem 0;
    border-top-color: #fff;
}

#geoline_ol_js_popup .arrow::before {
    bottom: 0;
    border-width: .5rem .5rem 0;
    border-top-color: #D1D1D1;
}
`, "",{"version":3,"sources":["webpack://./src/geoline.ol.css"],"names":[],"mappings":"AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,sBAAsB;IACtB,oBAAoB;CACvB,yBAAyB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;AAC7B","sourcesContent":["@import url(\"ol/ol.css\");\n\nbody {\n\tfont-family: sans-serif;\n}\n\n.ol-control button {\n\tcursor: pointer;\n\tbackground-color: #eab811;\n}\n\n.ol-control button:focus {\n\tcursor: pointer;\n\tbackground-color: #eab811;\n}\n\n.ol-control button:hover {\n\tbackground-color: #eab811;\n\tcolor: #999999;\n\tborder: 1px solid #999999;\n}\n\n.ol-attribution li {\n\tdisplay: block;\n\ttext-align: left;\n}\n\n.ol-attribution ul {\n    font-size: 10px;\n}\n\n/* Overlay */\n#geoline_ol_js_popup {\n    background-color: #fff;\n    border-radius: .2rem;\n\tborder: 1px solid #D1D1D1;\n}\n\n#geoline_ol_js_popup > div {\n    padding: 5px;\n}\n\n#geoline_ol_js_popup .header {\n    border-bottom: unset;\n    box-sizing: border-box;\n    border-top-right-radius: .2rem;\n    border-top-left-radius: .2rem;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #D1D1D1;\n}\n\n#geoline_ol_js_popup .arrow {\n    bottom: calc(-.5rem - 1px);\n    position: absolute;\n    padding: unset;\n    left: calc(100% / 2 - 0.5rem);\n    width: 1rem;\n    height: 0.5rem;\n}\n\n#geoline_ol_js_popup .arrow::after,\n#geoline_ol_js_popup .arrow::before {\n    position: absolute;\n    display: block;\n    content: \"\";\n    box-sizing: border-box;\n    border-color: transparent;\n    border-top-color: transparent;\n    border-style: solid;\n}\n\n#geoline_ol_js_popup .arrow::after {\n    bottom: 1px;\n    border-width: .5rem .5rem 0;\n    border-top-color: #fff;\n}\n\n#geoline_ol_js_popup .arrow::before {\n    bottom: 0;\n    border-width: .5rem .5rem 0;\n    border-top-color: #D1D1D1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
